export default __webpack_public_path__ + "static/media/trr-drink-wine-red.ea81341e.png";